$.onmount('[data-toggle=brand-selectize]', function () {
  var $el = $(this)

  $el.selectize(
    Object.assign(
      {
        highlight: false,
        create: false,
        plugins: $el.attr('multiple') ? ['remove_button'] : [],
        onChange: function (value) {
          var $container = $el.closest('.brand-shipping-method')
          var $label = $container.find('.brand-color-label')

          if ($label.length) {
            var selectedPlanName =
              $el[0].selectize.options[value]?.text.toLowerCase().replace(/[^a-z0-9-]/g, '-') ||
              'gray'

            console.log('Selected Plan Name:', selectedPlanName)

            // Remove existing bg- class and add the new one
            $label.removeClass(function (index, className) {
              return (className.match(/bg-\S+/g) || []).join(' ')
            })
            $label.addClass(`bg-${selectedPlanName}`)
          } else {
            console.warn('No .brand-color-label element found in the container.')
          }

          $el[0].dispatchEvent(new Event('change', { bubbles: true }))
        }
      },
      $el.data('options') || {}
    )
  )
})
